exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".profile[data-v-28499895]{margin:0 auto;max-width:15.6rem}", ""]);

// exports
